import { Component, Inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AlertCardComponent } from '../../../../../shared/components/alert-card/alert-card.component';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';

/** Uma informação retornada pelo GTIN que pode ser aplicada a um campo do formulário. */
export interface GtinCampoSelecionavel {
  /** Nome do FormControl que será atualizado. */
  chave: string;
  /** Rótulo amigável exibido ao usuário. */
  rotulo: string;
  /** Valor que será gravado no FormControl. */
  valor: any;
  /** Texto exibido no dialog para conferência. */
  textoExibicao: string;
  /** Se o checkbox está marcado (aplica ao confirmar). */
  selecionado: boolean;
  /** Se o checkbox pode ser marcado. Quando false, o campo não pode ser aplicado. */
  habilitado: boolean;
  /** Mensagem explicativa exibida no campo (ex.: unidade não cadastrada). */
  aviso?: string;
}

export interface GtinConsultaDialogData {
  gtin: string;
  campos: GtinCampoSelecionavel[];
}

@Component({
  selector: 'app-gtin-consulta-dialog',
  standalone: true,
  imports: [
    FormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    MatIconModule,
    MatCheckboxModule,
    AlertCardComponent,
  ],
  templateUrl: './gtin-consulta-dialog.component.html',
  styleUrl: './gtin-consulta-dialog.component.css',
})
export class GtinConsultaDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: GtinConsultaDialogData,
    public dialogRef: MatDialogRef<GtinConsultaDialogComponent>
  ) {}

  /** Campos que o usuário pode marcar (existe unidade/origem cadastrada correspondente). */
  get camposHabilitados(): GtinCampoSelecionavel[] {
    return this.data.campos.filter(c => c.habilitado);
  }

  get algumSelecionado(): boolean {
    return this.camposHabilitados.some(c => c.selecionado);
  }

  get todosSelecionados(): boolean {
    const habilitados = this.camposHabilitados;
    return habilitados.length > 0 && habilitados.every(c => c.selecionado);
  }

  toggleTodos(marcar: boolean): void {
    this.camposHabilitados.forEach(c => (c.selecionado = marcar));
  }

  close(): void {
    this.dialogRef.close(null);
  }

  confirmar(): void {
    this.dialogRef.close(this.data.campos.filter(c => c.selecionado));
  }
}
